import { DefaultStorage } from '../storage';
import { CONSUMER_TOKEN_KEY } from './consumerTokenKey';

export function createConsumerTokenStorage(): DefaultStorage {
  return new DefaultStorage(localStorage, CONSUMER_TOKEN_KEY);
}
